(function($){
    $.fn.clTimeline = function(){
        var _this = this, __init, _addListeners, _toggleFilter, _categoryFilter;
        _toggleFilter = function(el){
            $(el).toggleClass("active");
            _this.find(".tags_container").toggleClass("filter_active");
            _this.find(".tags_container").slideToggle();
        };

        _categoryFilter = function(el){
            $(el).toggleClass('active');
            if($(el).attr('href') === '#all' && $(el).hasClass('active')){
                _this.find('.filter_container a:gt(0)').removeClass('active');
            }else if($(el).attr('href') === '#all' && !$(el).hasClass('active')){
                $(el).toggleClass('active');
            }else if($(el).hasClass('active')){
                _this.find('.filter_container a:eq(0)').removeClass('active');
            }else if(!$(el).hasClass('active')){
                if(!_this.find('.filter_container a:gt(0).active').length){
                    _this.find('.filter_container a:eq(0)').addClass('active');
                }
            }

            var layer_name = [];
            var search_str = [];

            if(_this.find('.filter_container a:gt(0).active').length){
                _this.find('.filter_container a:gt(0).active').each(function(){
                    layer_name.push($(this).attr('data-filter'));
                    search_str.push('#base-layer .event_item[data-'+$(this).attr('data-filter')+']');
                });
                const url = new URL(window.location.href);
                url.searchParams.set('filter', layer_name.join('__'));
                window.history.pushState(null, null, url);
                if(!_this.find('#layer-'+layer_name.join('-')).length){

                    var layer = $('<div/>').attr('id', 'layer-'+layer_name.join('-')).addClass('layer');
                    console.log(search_str.join(', '));
                    console.log(_this.find(search_str.join(', ')));
                    _this.find(search_str.join(', ')).each(function(k, e){
                        var item = $(e).clone();
                        layer.append('<div class="grid grid--33"></div>')
                        layer.find('.grid:first').append(item);
                    });

                    _this.find('#events-container').append(layer);
                }

                _this.find('#events-container .layer.active').hide().removeClass('active');
                _this.find('#layer-'+layer_name.join('-')).show().addClass('active');
            } else {
                const url = new URL(window.location.href);
                url.searchParams.delete('filter');
                window.history.pushState(null, null, url);
                _this.find('#events-container .layer.active').hide().removeClass('active');
                _this.find('#base-layer').show().addClass('active');
            } 

            /* _this.find('#events-container .layer.active .month-container').each(function(key, element){
                if($(element).find('.whats-on-item').length) {
                    _this.find('a[data-month=' + $(this).data('month') + ']').addClass('active');
                }else{
                    $(element).hide();
                }
            }); */
        };
        _addListeners=function(){
            _this.find(".filter_button span").on('click', function(){
                _toggleFilter(this);
                console.log('click');
            });
            $('body').on('click', '#creative-learning .filter_container a', function(e){
                e.preventDefault();
                _categoryFilter(this)
                
            });
        }
        __init = function(){
            console.log(_this.find('.filter_container a.active:eq(0)').attr('href'));
            if(_this.find('.filter_container a.active').length){
                _categoryFilter(false);
                if(_this.find('.filter_container a.active:eq(0)').attr('href') !== '#all'){
                    _toggleFilter(_this.find(".filter_button span"));
                }
            }
            _addListeners();
        }

        __init();
    }   
    
    $(document).ready(function(){


        $('#creative-learning').clTimeline();
    });
    
        
    
})(jQuery)